import { FILTER_TYPES, PAGE_SIZE_FILTER } from 'constants/filterType';

export const SHIPMENT_FILTER_OPTIONS = [
  {
    field: 'payment_type',
    label: 'Payment Type',
    type: FILTER_TYPES.SELECT,
    options: [
      { value: '', label: 'All' },
      { value: 'prepaid', label: 'Prepaid' },
      { value: 'cod', label: 'COD' },
    ],
  },
  {
    field: 'product_name__icontains',
    label: 'Product Name',
    type: FILTER_TYPES.TEXT,
  },
  {
    field: 'product_sku__icontains',
    label: 'Product SKU',
    type: FILTER_TYPES.TEXT,
  },
  {
    field: 'brand__icontains',
    label: 'Brand Name',
    type: FILTER_TYPES.TEXT,
  },
  {
    field: 'shipment_code__icontains',
    label: 'Shipment Code',
    type: FILTER_TYPES.TEXT,
  },
  {
    field: 'invoice_code__icontains',
    label: 'Invoice Code',
    type: FILTER_TYPES.TEXT,
  },
  {
    field: 'state__icontains',
    label: 'State',
    type: FILTER_TYPES.TEXT,
  },
  {
    field: 'shipment_status',
    label: 'Shipment Status',
    type: FILTER_TYPES.MULTI_SELECT,
    options: [
      { value: 'created', label: 'Created' },
      { value: 'picking', label: 'Picking' },
      { value: 'picked', label: 'Picked' },
      { value: 'sidelined', label: 'Sidelined' },
      { value: 'packed', label: 'Packed' },
      { value: 'ready_to_ship', label: 'Ready to ship' },
      { value: 'added_to_manifest', label: 'Added to manifest' },
      { value: 'dispatched', label: 'Dispatched' },
      { value: 'delivered', label: 'Delivered' },
      { value: 'splitted', label: 'Splitted' },
      { value: 'return_acknowledged', label: 'Return acknowledged' },
      { value: 'returned', label: 'Returned' },
      { value: 'canceled', label: 'Canceled' },
    ],
  },
  {
    field: 'created_after',
    label: 'WMS Shipment Created After',
    type: FILTER_TYPES.DATE,
  },
  {
    field: 'created_before',
    label: 'WMS Shipment Created Before',
    type: FILTER_TYPES.DATE,
  },
  { ...PAGE_SIZE_FILTER },
];
